import React from 'react'
import styled from 'styled-components'

import { COLOR } from '@farewill/ui/tokens'
import { Divider, Wrapper } from '@farewill/ui'
import { screenMin } from '@farewill/ui/helpers/responsive'

import MeaningfulFuneral from 'views/cremation/components/MeaningfulFuneral'
import TrustpilotCarousel from 'components/TrustpilotWidget/TrustpilotCarousel'

import Hero from 'views/cremation/components/Hero'
import LowCostSection from 'views/cremation/components/LowCostSection'
import YourWay from 'views/cremation/components/YourWay'
import WhyFamilies from 'views/cremation/components/WhyFamilies'
import Serving from 'views/cremation/components/Serving'
import Guides from 'views/cremation/components/Guides'
import SliceChoices from './slices/SliceChoices'
import SliceFAQ from './slices/SliceFAQ'

const StyledDivider = styled(Divider)`
  display: none;

  ${screenMin.m`
    display: block;
  `}
`
interface ContentProps {
  ctaText?: string
  title?: string
  subtitle?: string
}

const Content = ({
  ctaText,
  title,
  subtitle,
}: ContentProps): React.ReactElement => (
  <>
    <Wrapper background={COLOR.WHITE}>
      <Hero ctaText={ctaText} title={title} subtitle={subtitle} />
      <LowCostSection bottomEdgeBackgroundColor={COLOR.ACCENT.PRIMARY_10} />
      <YourWay />
      <SliceChoices />
    </Wrapper>
    <Wrapper background={COLOR.ACCENT.PRIMARY_20}>
      <WhyFamilies />
    </Wrapper>
    <Wrapper background={COLOR.WHITE}>
      <Serving />
      <TrustpilotCarousel />
      <StyledDivider container />
      <SliceFAQ />
      <StyledDivider container />
      <Guides />
      <MeaningfulFuneral
        pageBackgroundColor={COLOR.WHITE}
        ctaText="Get a quote now"
      />
    </Wrapper>
  </>
)

export default Content
